/**
 * @desc 根据箱号批次号查询箱号列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/pageListPdf`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
